module.exports = __webpack_public_path__ + "img/logo.93eb4f82.png";